<template>
    <div class="ChurchPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-3 col-xl-2">
                    <div class="paper olive-green">
                        <b-nav pills vertical class="side-menu">
                            <b-nav-item v-on:click="ChangePaneShown('AddChurch')" v-bind:class="{ active: PanesShown == 'AddChurch' }"><font-awesome-icon :icon="['fa', 'plus']" /> Add Church</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Churches')" v-bind:class="{ active: PanesShown == 'Churches' }"><font-awesome-icon :icon="['fa', 'list']" /> Churches</b-nav-item>
                            <b-nav-item v-for="(churchRecord, churchSPMID) in OpenChurchRecords" v-bind:class="{ active: PanesShown == churchSPMID }">
                                <span v-on:click="ChangePaneShown(churchSPMID)">
                                    <font-awesome-icon :icon="['fa', 'church']" />
                                    {{ churchRecord.Church.Name }}
                                </span>
                                <span style="float:right" v-on:click="CloseChurchRecord(churchSPMID)">X</span>
                            </b-nav-item>
                        </b-nav>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <div v-show="PanesShown == 'AddChurch'">
                                <AddNewChurch />
                            </div>
                            <div v-show="PanesShown == 'Churches'">
                                <ChurchList />
                            </div>
                            <div v-for="(churchRecord, churchSPMID) in OpenChurchRecords" v-show="PanesShown == churchSPMID" v-if="churchRecord.SubProgramMembership != null">
                                <ChurchRecord v-bind:church-record-data="churchRecord" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    //import components
    import ChurchList from "./ChurchList.vue";
    import AddNewChurch from "./AddNewChurch.vue";
    import ChurchRecord from "./ChurchRecord/ChurchRecord.vue";

    export default {
        props: [],
        data: function () {
            return {
                PanesShown: "Churches"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            },
            CloseChurchRecord: function (spmID) {
                if (this.PanesShown == spmID) {
                    this.ChangePaneShown("Churches");
                }
                this.$store.commit("Churches.ChurchProfiles.Remove", spmID);
                
            }
        },
        computed: {
            OpenChurchRecords() {
                return this.$store.state.Churches.ChurchProfiles;
            }
        },
        components: {
            ChurchList,
            AddNewChurch,
            ChurchRecord
        }
    }
</script>

<style scoped>

</style>